import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user: {},
}

export const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },
        deleteUser: (state) => {
            state.user = {}
        },
    },
})

export const { setUser, deleteUser } = userSlice.actions

export default userSlice.reducer